/* eslint-disable react/no-unknown-property */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import moment from 'moment';
import React, {
    useState, useEffect, useLayoutEffect, useCallback, useContext, useRef,
} from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { CamelCase } from '../../redux/helper/CamelCase';
import { GenerateDateFormat } from '../../redux/helper/DateConverter';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import ThreeDotsLoader from '../../Components/LoadingDots';
import { userService } from '../../service/user.service';
import { DapService } from '../../service/dap.service';
import AdorSpinner from '../../Components/AdorSpinner';
import { exceptThisSymbols } from '../../constants';

const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 30,
};

export default function HandleDapCrud({ isUpdate }) {
    const history = useNavigate();
    const [productList, setproductList] = useState([]);
    const [productListLoading, setproductListLoading] = useState(false);
    const [productListLoadingMore, setproductListLoadingMore] = useState(false);
    const [productPage, setproductPage] = useState(1);
    const [productHasMore, setproductHasMore] = useState(false);
    const [productSegments, setproductSegments] = useState('');
    const [productListResetKey, setproductListResetKey] = useState(0);
    const productListRef = useRef(null);
    const PRODUCT_PAGE_LIMIT = 20;
    const [categoryId, setcategoryId] = useState('');
    const [adorLogo, setadorLogo] = useState(false);
    const { update_id } = useParams();
    const [mainCategory, setmainCategory] = useState([]);
    const [criteriaCategory, setcriteriaCategory] = useState([]);
    const [CriteriasubCategory1, setCriteriasubCategory1] = useState([]);
    const [CriteriasubCategory2, setCriteriasubCategory2] = useState([]);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [productToggleMainId, setproductToggleMainId] = useState('');
    const [territaryList, setterritaryList] = useState([]);
    const [constantManagers, setconstantManagers] = useState([]);
    const [threePL, setthreePL] = useState([]);
    const [Products, setProducts] = useState([]);
    const [concatSegment, setconcatSegment] = useState('');
    const [createSuccess, setcreateSuccess] = useState(false);
    const refer = useRef();
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);

    const handleDependency = useCallback(
        async () => {
            const manger = await userService.getManagers();
            if (manger.data.data.length > 0) {
                const arr = [];
                manger.data.data.forEach((mng, i) => {
                    mng.id = i;
                    mng.label = mng.CITY;
                    arr.push(mng);
                });
                setconstantManagers(arr);
            }

            const territry = await userService.getTerritory();
            if (territry.data.data.length > 0) {
                const arr = [];
                territry.data.data.forEach((mng, i) => {
                    mng.label = mng.NAME,
                    mng.id = i;
                    arr.push(mng);
                });
                setterritaryList(arr);
            }
            const thpl = await userService.getthreepl();
            if (thpl.data.data.length > 0) {
                const arr = [];
                thpl.data.data.forEach((mng, i) => {
                    mng.id = i;
                    mng.label = mng.DESCRIPTION;
                    mng.description = mng.DESCRIPTION;
                    arr.push(mng);
                });
                setthreePL(arr);
            }

            const prod = await userService.getProducts();
            if (prod.data.data.length > 0) {
                const arr = [];
                prod.data.data.forEach((mng, i) => {
                    arr.push({
                        id: `prod-${i}`, label: mng.MAIN_CATEGORY,
                    });
                });
                setProducts(arr);
            }
            const category = await distributorService.getOffersMainCategory();
            if (category.data.data.length > 0) {
                const arr = [];
                const val = {};

                category.data.data.forEach((mng, i) => {
                    arr.push({
                        id: `main--${i}`,
                        name: mng,
                        value: mng,
                        description: '',
                        category: [],
                        status: false,
                        CATEGORY_ID: arr.length + 1,
                        concat_segments: mng,

                    });
                });
                setmainCategory(arr);
            }
        },
    );
    useEffect(() => {
        handleDependency();
    }, []);

    const initialState = {
        freight_charges: '',
        offer_type: '',
        offer_value: '',
        description: '',
        type: '',
        start_date: '',
        end_date: '',
        ship_to: '',
        threepl: [],
        minimum_list_price: '0',
        maximum_list_price: '0',
        policy_name: '',
    };
    const initialErrorState = {
        policy_name: '',
        freight_charges: '',
        destination: '',
        type: '',
        start_date: '',
        end_date: '',
        threepl: '',
        description: '',
        ship_from: '',
    };
    const toggleState = {
        start_date: false,
        end_date: false,
        offer_type: false,
        type: false,
        threepl: false,
    };
    const CriterionTogle = {
        mainCategory: '',
        category: '',
        subCategory1: '',
        subCategory2: '',
        products: [],

    };
    const Initialcriteria = {
        main_category: '',
        category: '',
        subCategory1: '',
        subCategory2: '',
        products: [{ id: 0, value: '' }],
        minimum_list_price: '',
        maximum_list_price: '',
        minimum_value: '',
        maximum_value: '',
        trade_discount: '',
        additional_discount: '',
        maximum_discount: '',
        condition: 'AND',

    };
    const [isOn, setIsOn] = useState(false);
    const toggleSwitch = () => {
        if (state.policy_status !== 'Active') { setIsOn(!isOn); }
    };
    const [state, setState] = useState(initialState);
    const [errorState, seterrorState] = useState(initialErrorState);
    const [toggle, settoggle] = useState(toggleState);
    const [criteria, setcriteria] = useState([Initialcriteria]);
    const [criteriaToggle, setcriteriaToggle] = useState(CriterionTogle);
    const [fetchCategories, setfetchCategories] = useState(false);
    const [loading, setloading] = useState(false);
    const [pincodeSearchTerm, setPincodeSearchterm] = useState('');

    // useEffect(() => {
    //     setTimeout(() => {
    //         const handleOutsideClick = (event) => {
    //             if (refer.current
    //                 && !refer.current.contains(event.target)) {
    //                 settoggle(toggleState);
    //             }
    //         };
    //         document.addEventListener('mouseup', handleOutsideClick);
    //         return () => {
    //             // Unbind the event listener on clean up
    //             document.removeEventListener('mouseup', handleOutsideClick);
    //         };
    //     }, 1000);
    // }, [refer]);
    // Update
    const generateAddress = (arr) => {
        let val = '';
        arr.forEach((data) => {
            val += val === '' ? data : `,${data}`;
        });
        return val;
    };
    const getDetails = useCallback(
        async () => {
            setloading(true);
            const DapView = await DapService.GetDapDetails(update_id);
            if (!DapView.error && DapView.data.success_status) {
                const detail = DapView.data.data;
                detail.ship_from.label = detail.ship_from.CITY;
                if (detail.policy_status === 'Active') {
                    setIsOn(true);
                }
                if (detail.policy_status !== 'Draft' && detail.policy_status !== 'Active') {
                    SetErrorMessage('Only Draft and Active Policies can be Editable');
                    setcolorValue(true);
                    setTimeout(() => {
                        SetErrorMessage('');
                        setcolorValue(false);
                        window.location.href = '/manage-freight-policy';
                    }, 3000);
                    return;
                }
                if (state.policy_status !== 'Active') setIsOn(true);
                setState({
                    policy_name: detail.policy_name,
                    type: detail.destination_type,
                    start_date: new Date(detail.start_date),
                    end_date: new Date(detail.end_date),
                    freight_charges: detail.dap_charges,
                    threepl: [detail.ship_from],
                    description: generateAddress(detail.ship_to),
                    minimum_list_price: detail.min_list_price,
                    maximum_list_price: detail.max_list_price,
                    policy_status: detail.policy_status,

                });
                const arr = [];
                detail.product_categories.forEach((item) => {
                    const initstate = {
                        main_category: item.MAIN_CATEGORY,
                        category: item.SEGMENT2,
                        subCategory1: item.SEGMENT3,
                        subCategory2: item.SEGMENT4,
                        products: item.products,
                        CATEGORY_ID: item.CATEGORY_ID,

                    };
                    arr.push(initstate);
                });
                if (detail.product_categories[0].CATEGORY_CONCAT_SEGS.split('.').length > 2) {
                    fetchProduct(detail.product_categories[0].CATEGORY_CONCAT_SEGS);
                }
                setIsOn(detail.offer_status === '1' && true);
                if (detail.product_categories.length > 0) {
                    handleCategories(detail.product_categories[0].MAIN_CATEGORY, 'main_category').then(() => {
                        if (detail.product_categories[0].SEGMENT2) {
                            handleCategories(detail.product_categories[0].SEGMENT2, 'category', detail.product_categories[0].SEGMENT2).then(() => {
                                if (detail.product_categories[0].SEGMENT3) {
                                    handleCategories(detail.product_categories[0].SEGMENT3, 'subCategory1', '', detail.product_categories[0].SEGMENT3).then(() => {
                                        setcriteria(arr);
                                        setloading(false);
                                    });
                                } else {
                                    setcriteria(arr);
                                    setloading(false);
                                }
                            });
                        } else {
                            setcriteria(arr);
                            setloading(false);
                        }
                    });
                }
            }
        },
        [update_id],
    );

    useEffect(() => {
        if (isUpdate) {
            getDetails();
        }
    }, [getDetails]);
    useLayoutEffect(() => {
        if (productListRef.current) {
            productListRef.current.scrollTop = 0;
        }
    }, [productListResetKey]);
    //
    const fetchProduct = async (segments, page = 1) => {
        const paylaod = {
            concat_segments: segments,
            limit: PRODUCT_PAGE_LIMIT,
            page,
        };

        if (page === 1) {
            setproductListLoading(true);
        } else {
            setproductListLoadingMore(true);
        }
        const getproducts = await distributorService.getProductsListBySegments(paylaod);
        setproductListLoading(false);
        setproductListLoadingMore(false);
        if (!getproducts.error && getproducts.data.data.success_status) {
            const fetchedProducts = getproducts.data.data.data;
            setproductList((prevList) => (page === 1 ? fetchedProducts : [...prevList, ...fetchedProducts]));
            setcategoryId(getproducts.data.data.CATEGORY_ID);
            setproductSegments(segments);
            setproductPage(page);
            setproductHasMore(fetchedProducts.length === PRODUCT_PAGE_LIMIT);
            if (page === 1) {
                setproductListResetKey((key) => key + 1);
                setproductToggleMainId(0);
                setcriteriaToggle((prevState) => ({
                    ...prevState,
                    products: [0],
                }));
            }
        } else {
            SetErrorMessage(getproducts.message);
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
            setloading(false);
        }
    };
    const handleToggle = (key) => {
        const val = key === 'start_date' ? 'end_date' : 'start_date';
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
            [val]: false,
        }));
    };
    const handleCriteriatoggle = (i, key) => {
        setcriteriaToggle(Initialcriteria);
        setcriteriaToggle((prevState) => ({
            ...prevState,
            [key]: criteriaToggle[key] === '' ? i : '',
        }));
        setsubmitSelected(false);
    };
    const handleAddProduct = (i) => {
        const CriteriaDuplicate = [...criteria];
        CriteriaDuplicate[i].products.push({ id: CriteriaDuplicate[i].products.length + 1, value: '' });
        setcriteria(CriteriaDuplicate);
    };
    const handleCategories = useCallback(async (mainCategorySelected, type, sub1, sub2, sub3) => {
        let response;
        const seg = concatSegment;
        switch (type) {
        case 'main_category':
            setproductList([]);
            response = await distributorService.getSku({ SEGMENT1: mainCategorySelected });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, i) => {
                    item.id = `main_category--${i}`;
                    item.SEGMENT1 = item.name;
                    item.value = item.name;
                    item.main_category = mainCategorySelected;
                    arr.push(item);
                });
                setconcatSegment(mainCategorySelected);
                setcriteriaCategory(arr);
                const CriteriaDuplicate = [...criteria];
                // CriteriaDuplicate[sub1].CATEGORY_ID = response.data?.data[0]?.CATEGORY_ID;
                setcriteria(CriteriaDuplicate);
                fetchProduct(mainCategorySelected);
            } else {
                alert('Something went wrong');
            }
            break;
        case 'category':
            response = await distributorService.getSku({ SEGMENT2: sub1 });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, i) => {
                    item.id = `category--${i}`;
                    item.SEGMENT2 = item.name;
                    item.value = item.name;
                    item.category = item.name;
                    arr.push(item);
                });
                setCriteriasubCategory1(arr);
                setcategoryId(response.data.data[0].CATEGORY_ID);
                setconcatSegment(`${criteria[0].main_category}.${criteria[0].category}`);
                fetchProduct(`${mainCategorySelected}.${sub1}`);
            } else {
                alert('Something went wrong');
            }
            // setCriteriasubCategory1(response.data.data);
            break;
        case 'subCategory1':
            response = await distributorService.getSku({ SEGMENT3: sub3 });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, i) => {
                    if (item !== null) {
                        item.id = `subcategory--${i}`;
                        item.SEGMENT3 = item.name;
                        item.value = item.name;
                        item.subCategory1 = item.name;
                        arr.push(item);
                    }
                });

                fetchProduct(`${mainCategorySelected}.${sub1}.${sub3}`);
                if (arr[0].name !== null) {
                    setCriteriasubCategory2(arr);
                    setconcatSegment(`${concatSegment}.${sub2}`);
                }
            } else {
                alert('Something went wrong');
            }
            break;
        case 'subCategory2':
            response = await distributorService.getSku({ SEGMENT4: sub3 });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, i) => {
                    if (item !== null) {
                        item.id = `subcategory2--${i}`;
                        item.SEGMENT4 = item.name;
                        item.value = item.name;
                        item.subCategory2 = item.name;
                        arr.push(item);
                    }
                });

                fetchProduct(`${criteria[0].main_category}.${criteria[0].category}.${criteria[0].subCategory1}.${criteria[0].subCategory2}`);
            } else {
                alert('Something went wrong');
            }
            break;

        default: break;
        }
    }, [fetchCategories]);
    const handleSelectCategories = (type, i, value) => {
        const CriteriaDuplicate = [...criteria];
        CriteriaDuplicate[i][type] = value;
        setfetchCategories(!fetchCategories);
        switch (type) {
        case 'category':
            handleCategories(criteria[0].main_category, type, value);
            CriteriaDuplicate[i].subCategory1 = '';
            CriteriaDuplicate[i].subCategory2 = '';
            setCriteriasubCategory1([]);
            setCriteriasubCategory2([]);
            CriteriaDuplicate[i].products = [{ id: 0, value: '' }];
            setcriteria(CriteriaDuplicate);
            setproductList([]);
            setcriteria(CriteriaDuplicate);
            break;
        case 'main_category':
            handleCategories(value, type, i);
            CriteriaDuplicate[i].category = '';
            CriteriaDuplicate[i].subCategory1 = '';
            CriteriaDuplicate[i].subCategory2 = '';
            CriteriaDuplicate[i].products = [{ id: 0, value: '' }];
            setcriteria(CriteriaDuplicate);
            setproductList([]);
            break;
        case 'subCategory1':
            handleCategories(criteria[0].main_category, type, criteria[0].category, criteria[0].subCategory1, value);
            CriteriaDuplicate[i].subCategory2 = '';
            setcriteria(CriteriaDuplicate);
            setCriteriasubCategory2([]);
            CriteriaDuplicate[i].products = [{ id: 0, value: '' }];
            setcriteria(CriteriaDuplicate);
            setproductList([]);
            break;
        case 'subCategory2':
            handleCategories(criteria[0].main_category, 'subCategory2', criteria[0].category, criteria[0].subCategory1, value);
            setconcatSegment(`${concatSegment}.${value}`);
            CriteriaDuplicate[i].products = [{ id: 0, value: '' }];
            setcriteria(CriteriaDuplicate);
            setproductList([]);
            break;
        default: break;
        }
        setcriteriaToggle(Initialcriteria);
    };
    const InputChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setState((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };
    const handleDate = (val, key) => {
        if (key === 'start_date') {
            setState((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        setState((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };
    const handleAddProducts = (mainId, i, val) => {
        const tempData = [...criteria];
        const idx = tempData[0].products.map((item) => item.INVENTORY_ITEM_ID).indexOf(String(val.INVENTORY_ITEM_ID));
        if (idx === -1) {
            const prodDetails = {
                INVENTORY_ITEM_ID: String(val.INVENTORY_ITEM_ID),
                DESCRIPTION: val.DESCRIPTION,
                MODEL_DESCRIPTION: val.MODEL_DESCRIPTION,
                CONCATENATED_SEGMENTS: val.CONCATENATED_SEGMENTS,
                ENABLED_FLAG: val.ENABLED_FLAG,
                PRIMARY_UOM_CODE: val.PRIMARY_UOM_CODE,
                INVENTORY_ITEM_STATUS_CODE: val.INVENTORY_ITEM_STATUS_CODE,
                CUSTOMER_ORDER_ENABLED_FLAG: val.CUSTOMER_ORDER_ENABLED_FLAG,
                SHIPPABLE_ITEM_FLAG: val.SHIPPABLE_ITEM_FLAG,
            };
            tempData[mainId].products[i] = prodDetails;
            setcriteria(tempData);
            setcriteriaToggle(CriterionTogle);
        } else {
            SetErrorMessage('Product Already Exist!');
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
        }
    };
    const getSelectedProductLabel = (prod) => {
        const base = prod.MODEL_DESCRIPTION || prod.DESCRIPTION || '';
        const truncated = base.length > 102 ? `${base.substring(0, 102)}...` : base;
        return prod.CONCATENATED_SEGMENTS ? `${truncated} (${prod.CONCATENATED_SEGMENTS})` : truncated;
    };
    const handleCriterianProductsToggel = (i, mainID) => {
        const Toggle = { ...criteriaToggle };
        const producttoggle = Toggle.products;
        if (productToggleMainId === mainID && producttoggle.length > 0) {
            setproductToggleMainId('');
        } else {
            setproductToggleMainId(mainID);
        }
        if (producttoggle.includes(i)) {
            setcriteriaToggle((prevState) => ({
                ...prevState,
                products: [],
            }));
            return;
        }
        producttoggle.push(i);

        setcriteriaToggle((prevState) => ({
            ...prevState,
            products: producttoggle,
        }));
    };
    const handleProductListScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight < 20 && productHasMore && !productListLoadingMore) {
            fetchProduct(productSegments, productPage + 1);
        }
    };
    const validate = () => {
        let isvalid = true;
        Object.keys(state).forEach((key) => {
            switch (key) {
            case 'policy_name':
            case 'freight_charges':
            case 'type':
            case 'threepl':
            case 'description':
            case 'start_date':
            case 'end_date':
                if (state[key] === '' || state[key].length === 0) {
                    seterrorState((prevState) => ({
                        ...prevState,
                        [key]: `${key} is required`,
                    }));
                    isvalid = false;
                }
                if (state.type === 'Outstation') {
                    isvalid = true;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };
    const Criteriavalidate = () => {
        let isvalid = true;
        criteria.forEach((key) => {
            if (key.main_category === '') {
                isvalid = false;
            }
        });
        return isvalid;
    };
    const handleProductsValue = (prod) => {
        const arr = [];
        prod.forEach((val) => {
            if (Object.keys(val).length > 2) {
                const sanitized = {};
                Object.keys(val).forEach((key) => {
                    if (val[key] !== null && val[key] !== undefined) {
                        sanitized[key] = val[key];
                    }
                });
                arr.push(sanitized);
            }
        });
        return arr;
    };
    const handleSegment = () => {
        let final = '';
        if (criteria[0].main_category !== '') {
            final = `${criteria[0].main_category}`;
        }
        if (criteria[0].category !== '') {
            final += `.${criteria[0].category}`;
        }
        if (criteria[0].subCategory1 !== '') {
            final += `.${criteria[0].subCategory1}`;
        }
        if (criteria[0].subCategory2 !== '') {
            final += `.${criteria[0].subCategory2}`;
        }
        return final;
    };
    const handleCriterionPayload = () => {
        const arr = [];
        criteria.forEach((item, i) => {
            const init = {
                // CATEGORY_ID: ProductList[0].CATEGORY_ID,
                MAIN_CATEGORY: item.main_category,
                CATEGORY_CONCAT_SEGS: handleSegment(),
                SEGMENT1: criteria[0].main_category,
                SEGMENT2: criteria[0].category,
                SEGMENT3: criteria[0].subCategory1,
                SEGMENT4: criteria[0].subCategory2,
                products: handleProductsValue(item.products),
            };
            arr.push(init);
        });
        return arr;
    };
    const handleDropdown = (value, id, obj, remove) => {
        setsubmitSelected(false);
        const arr = { ...state };
        const index = arr[id].map((key) => key.label || key).indexOf(value.label || value);
        if (index === -1) {
            setState((prevState) => ({
                ...prevState,
                [id]: [value],
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                [id]: [],
            }));
        }

        settoggle((prevState) => ({
            ...prevState,
            [id]: false,
        }));
    };
    const get3Pl = (obj) => {
        const arr = [];
        obj.forEach((val) => {
            arr.id = undefined;
            arr.label = undefined;
            arr.push({
                CITY: val.CITY,
                DESCRIPTION: val.DESCRIPTION,
                IS_ACTIVE_FLAG: val.IS_ACTIVE_FLAG,
                OPERATING_UNIT_ID: String(val.OPERATING_UNIT_ID),
                ORGANIZATION_CODE: val.ORGANIZATION_CODE,
                ORGANIZATION_ID: String(val.ORGANIZATION_ID),
                ORGANIZATION_NAME: val.ORGANIZATION_NAME,
                STATE: val.STATE === null ? 'null' : val.STATE,
                POSTAL_CODE: val.POSTAL_CODE,
            });
        });
        return arr[0];
    };
    const handleCreatePolicy = async (e) => {
        e.preventDefault();
        seterrorState(initialErrorState);
        setloading(true);
        setsubmitSelected(true);
        if (!validate() || !Criteriavalidate()) {
            setloading(false);
            return;
        }
        // if(state.minimum_list_price !=='0' && state.maximum_list_price !=='0'){
        //     if(state.minimum_list_price)
        // }
        if (state.description.split(',').length === 0) {
            setloading(false);
            SetErrorMessage('Please enter valid ship to pincode');
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
            return;
        }
        if (Number(state.minimum_list_price) > Number(state.maximum_list_price)) {
            setloading(false);
            SetErrorMessage('Minimum list price shouldn\'t be greater than Maximum List price');
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
            return;
        }
        const payload = {
            policy_name: state.policy_name,
            start_date: moment(state.start_date).format('YYYY-MM-DD'),
            end_date: moment(state.end_date).format('YYYY-MM-DD'),
            ship_to: state.description.split(','),
            destination_type: state.type,
            policy_status: isOn ? 'Active' : 'Draft',
            ship_from: get3Pl(state.threepl),
            dap_charges: state.freight_charges,
            product_categories: handleCriterionPayload(),
        };
        payload.min_list_price = state.minimum_list_price === '' ? undefined : state.minimum_list_price;
        payload.max_list_price = state.maximum_list_price === '' ? undefined : state.maximum_list_price;
        let create;
        if (isUpdate) {
            create = await DapService.UpdatePolicy(payload, update_id);
        } else {
            create = await DapService.createPolicy(payload);
        }

        if (!create.error && create.data.success_status) {
            SetSuccessMessage(create.data.message || `Policy has been ${isUpdate ? 'updated' : 'created'} successfully!`);
            setTimeout(() => {
                SetSuccessMessage('');
                setcolorValue(false);
                history('/manage-freight-policy');
            }, 3000);
        } else {
            SetErrorMessage(create.message);
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
            setloading(false);
        }
    };
    const findItemExist = (key, val) => state[key].map((item) => item.label).indexOf(val.label);

    const pincodeSearchHandler = (pincodeValue) => {
        if (pincodeSearchTerm === '') {
            return pincodeValue;
        } if ((pincodeValue.DESCRIPTION).toLowerCase().includes(pincodeSearchTerm.toLowerCase())) {
            return pincodeValue;
        }
    };

    return (
        <div className="relative">
            {loading && <AdorSpinner />}
            <div className="flex items-center">
                <Link to="/manage-freight-policy">
                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                </Link>
                <h5 className="text-[#555259] text-xs4 font-normal">{isUpdate ? 'Update Freight Policy' : 'Create New Freight Policy'}</h5>
            </div>
            <div className="flex justify-center items-end flex-col">
                <span className="text-xs2 mb-1.5 pr-[37px] font-semibold text-[#808285]">
                    Status
                </span>
                <div className="flex items-center">
                    <div className="switch" data-isOn={isOn} onClick={toggleSwitch}>
                        <motion.div className="handle" layout transition={spring} />
                    </div>
                    <span className="text-[#ffff]">.</span>
                    {' '}
                    <div>
                        {isOn ? (
                            <div>
                                {' '}
                                {' '}
                                Active
                            </div>
                        ) : (
                            <div>
                                {' '}
                                {' '}
                                Draft
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <div className="flex mt-3.5 -mx-2">
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <input
                            disabled={state.policy_status === 'Active'}
                            onChange={(e) => InputChange(e)}
                            type="text"
                            id="policy_name"
                            value={state.policy_name}
                            className={`h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && errorState.policy_name !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                            autoComplete="off"
                            onFocus={() => setsubmitSelected(false)}
                        />
                        <label htmlFor="policy_name" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Policy Name
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                        {submitSelected && errorState.policy_name !== '' && <span className="text-s font-light text-[#ED1C24]">Policy name is required</span>}

                    </div>
                </div>
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <label htmlFor="offercode12" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Start Date
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                        <img src="/images/Iconawesome-calendar-alt.svg" alt="icon" className="absolute top-4 right-5 cursor-pointer" onClick={() => handleToggle('start_date')} />
                        <input
                            datepicker
                            disabled={state.policy_status === 'Active'}
                            value={state.start_date !== '' ? GenerateDateFormat(state.start_date) : ''}
                            datepicker-autohide
                            type="text"
                            onClick={() => handleToggle('start_date')}
                            className={`cursor-pointer text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && errorState.start_date !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                        />
                    </div>
                    <div>
                        {toggle.start_date && <Calendar minDate={moment(new Date()).toDate()} value={state.start_date} onChange={(val) => handleDate(val, 'start_date')} />}
                    </div>
                    {submitSelected && errorState.start_date !== '' && <span className="text-s font-light text-[#ED1C24]">Start Date is required</span>}

                </div>
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <label htmlFor="offercode11" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            End Date
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                        <img
                            src="/images/Iconawesome-calendar-alt.svg"
                            alt="icon"
                            className="absolute top-4 right-5 cursor-pointer"
                            onClick={() => handleToggle('end_date')}

                        />
                        <input
                            disabled={state.policy_status === 'Active'}
                            datepicker
                            onClick={() => handleToggle('end_date')}
                            datepicker-autohide
                            type="text"
                            value={state.end_date !== '' ? GenerateDateFormat(state.end_date) : ''}
                            className={`cursor-pointer text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && errorState.end_date !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                        />
                    </div>
                    <div>
                        {toggle.end_date && <Calendar value={state.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(state.start_date).toDate()} />}
                    </div>
                    {submitSelected && errorState.end_date !== '' && <span className="text-s font-light text-[#ED1C24]">End Date is required</span>}

                </div>
            </div>
            <div className="mt-5 flex -mx-2">
                <div className="px-2 w-1/3">
                    <div className="dropdown relative">
                        <button
                            disabled={state.policy_status === 'Active'}
                            type="button"
                            onClick={() => {
                                handleToggle('type');
                                setsubmitSelected(false);
                            }}
                            id="HIP"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className={`dropdown-to text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && errorState.type !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                        >
                            <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Destination Type
                                {' '}
                                <span className="text-[#ED1C24]">*</span>
                            </p>
                            {toggle.type === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                            {state.type}
                        </button>
                        {submitSelected && errorState.type !== '' && <span className="text-s font-light text-[#ED1C24]">Destination Type is required</span>}

                        <ul className={`dropdown-menu overflow-auto  w-full absolute ${toggle.type ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="HIP" style={{ borderRadius: '8px' }}>
                            <li
                                className="pl-3.5 w-full pt-3 bg-[#ffffff]"
                                onClick={() => {
                                    setState((prevState) => ({
                                        ...prevState,
                                        type: 'Local',
                                    }));
                                    settoggle((prevState) => ({
                                        ...prevState,
                                        type: false,
                                    }));
                                }}
                            >
                                <a className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp" href="javascript:void(0)">Local</a>
                            </li>
                            <li
                                className="pl-3.5 w-full pt-2 pb-3 bg-[#FFFFFF]"
                                onClick={() => {
                                    setState((prevState) => ({
                                        ...prevState,
                                        type: 'Outstation',
                                    }));
                                    settoggle((prevState) => ({
                                        ...prevState,
                                        type: false,
                                    }));
                                }}
                            >
                                <a className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)">Outstation</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <input
                            disabled={state.policy_status === 'Active'}
                            onChange={(e) => {
                                if (e.target.value <= 100.01) {
                                    InputChange(e);
                                }
                            }}
                            type="text"
                            id="freight_charges"
                            value={state.freight_charges}
                            className={`h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && errorState.freight_charges !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                            autoComplete="off"
                            onFocus={() => setsubmitSelected(false)}
                        />
                        <label htmlFor="freight_charges" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Freight Charges (In Percentage)
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                        {submitSelected && errorState.freight_charges !== '' && <span className="text-s font-light text-[#ED1C24]">Freight Charges is required</span>}

                    </div>
                </div>
                <div className="dropdown relative w-1/3">
                    <button
                        disabled={state.policy_status === 'Active'}
                        onClick={() => handleToggle('threepl')}
                        type="button"
                        id="territory"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className={`dropdown-to text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && errorState.threepl !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                    >
                        <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF] selected-field">
                            Ship From
                            <span className="text-[#ED1C24]">*</span>
                        </span>
                        {state?.threepl?.length === 0 && <p style={{ color: 'grey' }}>Select Ship from</p>}
                        {toggle.threepl === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                            : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                    </button>
                    {submitSelected && errorState.threepl !== '' && <span className="text-s font-light text-[#ED1C24]">Ship from is required</span>}
                    <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggle.threepl ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">
                        <input
                            type="text"
                            name="search"
                            id="search"
                            autoComplete="off"
                            // value={searchValue || ''}
                            onChange={(e) => {
                                setPincodeSearchterm((e.target.value));
                            }}
                            className={`w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg ${toggle.threepl ? 'show' : 'hidden'}`}
                            placeholder="Search"
                        />
                        {/* <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" /> */}

                        {toggle.threepl && threePL.length > 0 && threePL.filter((pincodeValue) => pincodeSearchHandler(pincodeValue)).map((threeplValue) => (
                            <li className="pl-10 w-full pt-2" key={`three-${threeplValue.label}`}>

                                <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">

                                    <p
                                        className="text-sm font-normal text-[#555259] pl-2 cursor-pointer"
                                        onClick={() => {
                                            handleDropdown(threeplValue, 'threepl', 'object');
                                        }}
                                    >
                                        {threeplValue.description}
                                    </p>
                                </div>
                            </li>
                        ))}

                    </ul>
                    <div className="flex pt-2.5 flex-wrap w-full ">
                        { state?.threepl?.length > 0 && state.threepl.map((selected3pl) => (

                            <div className="flex bg-[#F2F2F3] rounded-lg mt-2   ml-2  px-2 py-2 w-[120px] h-[33px] cursor-pointer items-center justify-center">
                                <p className="text-sm font-normal text-[#555259]">{selected3pl.label}</p>
                                <img
                                    src="/images/cross-mark.svg"
                                    alt="icon"
                                    className="pl-2 w-4"
                                    onClick={() => setState((prevState) => ({
                                        ...prevState,
                                        threepl: [],
                                    }))}
                                />
                            </div>

                        ))}
                    </div>

                </div>
            </div>
            {state.type !== 'Outstation'
            && (
                <div className="mt-5 relative">
                    <label htmlFor="description" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                        Ship to (Pin codes)
                        <span className="text-[#ED1C24]">*</span>

                    </label>
                    <textarea
                        name="description"
                        type="number"
                        id="description"
                        placeholder="677418,567656,23456,"
                        value={state.description}
                        onChange={(e) => InputChange(e)}
                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.,]/g, ''); }}
                        disabled={state.type === 'Outstation'}
                        className={`w-full resize-none h-[110px] rounded-lg outline-0 border border-[#${submitSelected && errorState.description !== '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-4 py-3.5`}
                    />
                    {submitSelected && errorState.description !== '' && <span className="text-s font-light text-[#ED1C24]">Ship to is required</span>}

                </div>
            ) }
            <div className="" ref={refer}>
                <form onSubmit={(e) => handleCreatePolicy(e)}>
                    <div className="mt-2 rounded-[22px] bg-[#F5F5FA] px-2.5 pt-4 pb-4 w-full">
                        {criteria.length > 0 && criteria.map((item, i) => (
                            <div className="creation2">
                                <div className="pb-1.5 flex justify-between  px-[22px]" />
                                <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-10 pb-11">
                                    <div className="flex -mx-1 relative">
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative" onClick={() => handleCriteriatoggle(i, 'mainCategory')}>
                                                <button
                                                    disabled={state.policy_status === 'Active'}
                                                    type="button"
                                                    id="m12"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    className={`dropdown-to h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && item.main_category === '' ? 'ED1C24' : 'D8DDE3'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 text-left`}
                                                >
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Main Category
                                                        {' '}
                                                        <span className="text-[#ED1C24]">*</span>
                                                    </p>
                                                    <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                    {item.main_category}
                                                </button>
                                                {submitSelected && item.main_category === '' && <span className="text-s font-light text-[#ED1C24]">Main Category is required</span>}

                                                <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${criteriaToggle.mainCategory === i ? '' : 'hidden'}`} aria-labelledby="m12">
                                                    {mainCategory.map((main, mainKey) => (
                                                        <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={mainKey}>
                                                            <a className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp" href="javascript:void(0)" onClick={() => handleSelectCategories('main_category', i, main.value)}>{main.value}</a>
                                                        </li>
                                                    ))}

                                                </ul>
                                            </div>
                                        </div>
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button
                                                    disabled={state.policy_status === 'Active'}

                                                    type="button"
                                                    id="m22"
                                                    data-bs-toggle="dropdown"
                                                    onClick={() => handleCriteriatoggle(i, 'category')}
                                                    aria-expanded="false"
                                                    className="dropdown-to h-12 w-full text-left rounded-lg outline-0 border border-[#D8DDE3] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                                >
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Product Group
                                                    </p>
                                                    <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                    {criteria[i].category}

                                                </button>

                                                <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] ${criteriaCategory.length > 0 ? '' : 'hidden'} rounded-lg shadow-s2 z-[9999] ${criteriaToggle.category === i ? '' : 'hidden'}`} aria-labelledby="m22" style={{ height: '100px', overflow: 'auto' }}>
                                                    {criteriaCategory.map((category) => (
                                                        <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={category.CATEGORY_ID}>
                                                            <a
                                                                className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp"
                                                                href="javascript:void(0)"
                                                                onClick={() => handleSelectCategories('category', i, category.value)}
                                                            >
                                                                {category.value}
                                                                {' '}
                                                            </a>
                                                        </li>
                                                    ))}

                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex -mx-1 mt-3.5">
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button
                                                    disabled={state.policy_status === 'Active'}

                                                    type="button"
                                                    onClick={() => handleCriteriatoggle(i, 'subCategory1')}
                                                    id="s121"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    className="dropdown-to text-left h-12 w-full rounded-lg outline-0 border border-[#D8DDE3] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                                >
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Product Sub Group
                                                    </p>
                                                    <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                    {criteria[i]?.subCategory1?.length > 20
                                                        ? `${criteria[i].subCategory1.substring(0, 20)}...` : criteria[i].subCategory1}
                                                </button>

                                                <ul className={`dropdown-menu w-full 1 absolute${CriteriasubCategory1.length > 0 && CriteriasubCategory1[0].name !== null ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${criteriaToggle.subCategory1 === i && CriteriasubCategory1.length > 0 ? '' : 'hidden'}`} aria-labelledby="s121" style={{ height: '100px', overflow: 'auto' }}>
                                                    {CriteriasubCategory1.length > 0 && CriteriasubCategory1.map((category1, cidx) => (
                                                        <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={cidx}>
                                                            <a
                                                                className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp"
                                                                href="javascript:void(0)"
                                                                onClick={() => handleSelectCategories('subCategory1', i, category1.value)}
                                                            >
                                                                {category1.value}

                                                            </a>
                                                        </li>
                                                    ))}

                                                </ul>
                                            </div>
                                        </div>
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button
                                                    disabled={state.policy_status === 'Active'}

                                                    type="button"
                                                    id="s22"
                                                    onClick={() => handleCriteriatoggle(i, 'subCategory2')}
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    className="dropdown-to h-12 text-left w-full rounded-lg outline-0 border border-[#D8DDE3] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                                >
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Product Sub Sub Group
                                                    </p>
                                                    <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                    {criteria[i]?.subCategory2?.length > 20
                                                        ? `${criteria[i].subCategory2.substring(0, 20)}...` : criteria[i].subCategory2}

                                                </button>
                                                <ul className={`dropdown-menu w-full absolute ${CriteriasubCategory2.length > 0 && CriteriasubCategory2[0].name !== null ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${criteriaToggle.subCategory2 === i ? '' : 'hidden'}`} aria-labelledby="s22" style={{ height: '100px', overflow: 'auto' }}>
                                                    {CriteriasubCategory2.length > 0 && CriteriasubCategory2.map((category2, cidx) => (
                                                        category2.value !== null && (
                                                            <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={cidx}>
                                                                <a
                                                                    className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp"
                                                                    href="javascript:void(0)"
                                                                    onClick={() => handleSelectCategories('subCategory2', i, category2.value)}
                                                                >
                                                                    {category2.value}

                                                                </a>
                                                            </li>
                                                        )
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex -mx-1 mt-3.5 items-center w-full">
                                        <div className="px-1 w-full">
                                            {item.products.length > 0 && item.products.map((prod, prodcount) => (
                                                <div className="dropdown relative w-full p-1" key={prodcount}>
                                                    <button
                                                        disabled={state.policy_status === 'Active' || productListLoading}

                                                        type="button"
                                                        onClick={() => handleCriterianProductsToggel(prodcount, i)}
                                                        id="s122"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                        className="dropdown-to text-left h-12 w-full pb-1 rounded-lg outline-0 border border-[#D8DDE3] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 disabled:cursor-not-allowed disabled:opacity-60"
                                                    >
                                                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 mt-1 bg-[#FFFFFF]">
                                                            Product(SKU)
                                                            {' '}
                                                            {prodcount + 1}
                                                        </p>
                                                        <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                        {productListLoading ? 'Fetching products...' : getSelectedProductLabel(prod)}
                                                    </button>
                                                    <ul ref={productListRef} className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${productToggleMainId === i && criteriaToggle.products.includes(prodcount) && productList.length > 0 ? '' : 'hidden'}`} aria-labelledby="s122" style={{ height: '100px', overflow: 'auto' }} onScroll={handleProductListScroll}>
                                                        {productList.length > 0 && productList.map((product) => (
                                                            <li
                                                                className="pl-3.5 w-full pt-3 bg-[#ffffff]"
                                                                onClick={() => handleAddProducts(i, prodcount, product)}
                                                            >
                                                                <a className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp" href="javascript:void(0)">
                                                                    {product.MODEL_DESCRIPTION || product?.DESCRIPTION}
                                                                    {' '}
                                                                    (
                                                                    {product.CONCATENATED_SEGMENTS}
                                                                    )

                                                                </a>
                                                            </li>
                                                        ))}
                                                        {productListLoadingMore && (
                                                            <li className="pl-3.5 w-full pt-3 pb-3 bg-[#ffffff] text-xs6 text-[#808285]">Loading more...</li>
                                                        )}

                                                    </ul>
                                                </div>
                                            ))}
                                            <div className="px-1 w-1/3">
                                                <button
                                                    disabled={state.policy_status === 'Active'}
                                                    type="button"
                                                    className="text-xs2 font-semibold text-[#555259] pl-4 add-product"
                                                    onClick={() => handleAddProduct(i)}
                                                >
                                                    + Add product
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="flex -mx-1 mt-3.5">
                                        <div className="px-1 w-1/3">
                                            <div className="relative">
                                                <input
                                                    disabled={state.policy_status === 'Active'}

                                                    type="Number"
                                                    id="minimum_list_price"
                                                    value={state.minimum_list_price}
                                                    onChange={(e) => InputChange(e, i)}
                                                    className="h-12 w-full rounded-lg outline-0 border border-[#D8DDE3] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                                    autoComplete="off"
                                                    onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                />
                                                <label htmlFor="minimum_list_price" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Minimum List Price</label>
                                            </div>
                                        </div>
                                        <div className="px-1 w-1/3">
                                            <div className="relative">
                                                <input
                                                    disabled={state.policy_status === 'Active'}
                                                    type="Number"
                                                    onChange={(e) => InputChange(e, i)}
                                                    id="maximum_list_price"
                                                    value={state.maximum_list_price}
                                                    className="h-12 w-full rounded-lg outline-0 border border-[#D8DDE3] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                                    autoComplete="off"
                                                    onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                />
                                                <label htmlFor="maximum_list_price" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Maximum List Price</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="mt-4 mb-8 flex justify-center">
                        <button disabled={loading} type="submit" className="w-[235px] h-[38px] bg-[#555259] text-xs6 font-bold text-[#FFFFFF] rounded-lg create-deal flex items-center justify-center">
                            {loading ? <ThreeDotsLoader /> : isUpdate ? 'Update Policy' : 'Create Policy'}
                        </button>
                    </div>
                </form>

            </div>
        </div>
    );
}
